import React from 'react';
import { Typography } from 'antd';
import { pinFilled } from '../../../elements/components/Icons';
import ReactQuill from 'react-quill';
import { TelephoneDisplayCard } from '../../../elements/components/TelephoneDisplay';
import { WebsiteDisplayCard } from '../../../elements/components/WebsiteDisplay';
import { EmailDisplayCard } from '../../../elements/components/EmailDisplay';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const { Title } = Typography;

const modules = {
  toolbar: '#toolbar-read-only-resource-card',
};

const DashboardResourcesCard = ({
  item,
  onChange,
  addStyle,
  className,
  showDetail,
  trackerDashboardEvent,
  ...props
}) => {
  const trackerResource = (event, params = {}) => {
    trackerDashboardEvent(event, {
      resourceId: item.id,
      resourceName: item.name,
      ...params,
    });
  };

  return (
    <div
      className={className}
      key={item.id}
      onClick={() => {
        trackerResource(mixpanelEventsEnum.DASHBOARD.RESOURCE_OPEN_PREVIEW);
        showDetail(item.id);
      }}
      style={{
        border: item?.partnership
          ? `2px solid ${item?.partnership?.color_hex}`
          : null,
        ...addStyle,
      }}
    >
      <div
        className={'icon-active'}
        style={{
          display: 'flex',
          justifyContent: 'end',
          width: '100%',
        }}
      >
        {pinFilled(12, 18)}
      </div>

      <Title className='section-resource-card-list-title' level={5}>
        {item.name}
      </Title>
      {item?.description !== '<p><br></p>' && item?.description.length > 0 && (
        <div className='section-resource-card-list-description'>
          <div id='toolbar-read-only-resource-card'></div>
          <ReactQuill modules={modules} readOnly value={item.description} />
        </div>
      )}
      {(item?.website || item?.telephone || item?.email) && (
        <div className='info-container'>
          {item?.website ? (
            <WebsiteDisplayCard
              website={item.website}
              onClick={(e) =>
                trackerResource(
                  mixpanelEventsEnum.DASHBOARD.RESOURCE_OPEN_LINK,
                  {
                    linkType: 'link',
                  }
                )
              }
            />
          ) : null}
          {item?.telephone ? (
            <TelephoneDisplayCard
              telephone={item.telephone}
              onClick={(e) =>
                trackerResource(
                  mixpanelEventsEnum.DASHBOARD.RESOURCE_OPEN_LINK,
                  {
                    linkType: 'phone',
                  }
                )
              }
            />
          ) : null}
          {item?.email ? (
            <EmailDisplayCard
              email={item.email}
              onClick={(e) =>
                trackerResource(
                  mixpanelEventsEnum.DASHBOARD.RESOURCE_OPEN_LINK,
                  {
                    linkType: 'email',
                  }
                )
              }
            />
          ) : null}
        </div>
      )}
    </div>
  );
};

export default DashboardResourcesCard;
